import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GETTING_USER_ASSET_INFO,
  CREATING_USER_ASSET_LIABILITY_INFO,
  UPDATING_USER_ASSET_LIABILITY_INFO,
  UPDATE_ASSETS_AND_NET_WORTH_INFO,
  GETTING_USER_LIABILITY_INFO,
  UPDATE_LIABILITIES_NET_WORTH_INFO,
} from './actionTypes';

import { API_ENDPOINT } from '../constants';

export const updateUserAssetsAndNetWorthInfo = (dispatch, assetsAndNetWorthInfo) => {
  dispatch({ type: UPDATE_ASSETS_AND_NET_WORTH_INFO, payload: assetsAndNetWorthInfo });
};

export const getUserAssetInfo = createAsyncThunk(
  GETTING_USER_ASSET_INFO,
  async ({ id, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response;
    try {
      const res = await axios.get(`${API_ENDPOINT}/users/${id}/assets`, {
        headers: {
          Authorization: `Bearer ${tokenValue}`,
        },
      });
      response = res?.data || {};
    } catch (error) {
      console.error(error);
    }

    updateUserAssetsAndNetWorthInfo(dispatch, response[0]);
  },
);

export const updateUserLiabilitiesAndNetWorthInfo = (dispatch, liabilitiesAndNetWorthInfo) => {
  dispatch({ type: UPDATE_LIABILITIES_NET_WORTH_INFO, payload: liabilitiesAndNetWorthInfo });
};

export const createUserAssetInfo = createAsyncThunk(
  CREATING_USER_ASSET_LIABILITY_INFO,
  async ({ Assets, usersId, tokenValue }, methods) => {
    const { dispatch } = methods;

    let response = {};

    try {
      const res = await axios.post(
        `${API_ENDPOINT}/assets/new/`,
        {
          ...Assets,
          usersId,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenValue}`,
          },
        },
      );
      response = res?.data || {};

      updateUserAssetsAndNetWorthInfo(dispatch, response);
    } catch (error) {
      console.error(error);
    }
  },
);

export const createUserLiabilityInfo = createAsyncThunk(
  CREATING_USER_ASSET_LIABILITY_INFO,
  async ({ Liabilities, usersId, tokenValue }, methods) => {
    const { dispatch } = methods;

    let response = {};

    try {
      const res = await axios.post(
        `${API_ENDPOINT}/liabilities/new/`,
        {
          ...Liabilities,
          usersId,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenValue}`,
          },
        },
      );
      response = res?.data || {};

      updateUserLiabilitiesAndNetWorthInfo(dispatch, response);
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateUserAssetInfo = createAsyncThunk(
  UPDATING_USER_ASSET_LIABILITY_INFO,
  async ({ Assets, usersId, tokenValue }, methods) => {
    const { dispatch } = methods;

    let response = {};

    try {
      const res = await axios.patch(
        `${API_ENDPOINT}/assets/${Assets.id}/`,
        {
          ...Assets,
          usersId,
          model: 'asset',
        },
        {
          headers: {
            Authorization: `Bearer ${tokenValue}`,
          },
        },
      );
      response = res?.data || {};

      updateUserAssetsAndNetWorthInfo(dispatch, response);
    } catch (error) {
      console.error(error);
    }
  },
);

export const getUserLiabilityInfo = createAsyncThunk(
  GETTING_USER_LIABILITY_INFO,
  async ({ id, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response;
    try {
      const res = await axios.get(`${API_ENDPOINT}/users/${id}/liabilities`, {
        headers: {
          Authorization: `Bearer ${tokenValue}`,
        },
      });
      response = res?.data || {};
    } catch (error) {
      console.error(error);
    }

    updateUserLiabilitiesAndNetWorthInfo(dispatch, response?.[0]);
  },
);
